



































import { Component, Vue } from 'vue-property-decorator';
import DataBox1 from '@/views/dataView/ziYangDataViewBlack/chart/dataBox1.vue';
import DataBox2 from '@/views/dataView/ziYangDataViewBlack/chart/dataBox2.vue';
import DataBox3 from '@/views/dataView/ziYangDataViewBlack/chart/dataBox3.vue';
import DataBox4 from '@/views/dataView/ziYangDataViewBlack/chart/dataBox4.vue';
import DataBox5 from '@/views/dataView/ziYangDataViewBlack/chart/dataBox5.vue';
import DataBox6 from '@/views/dataView/ziYangDataViewBlack/chart/dataBox6.vue';
import { institutionServer, regionServe } from '@/api/installServer';
import axios from 'axios';
import { arrayToTree } from '@/util/arrayToTree';
Vue.prototype.$axios = axios;

// var moment = require('moment');
// moment().format();
@Component({
  components: { DataBox1, DataBox2, DataBox3, DataBox4, DataBox5, DataBox6 },
})
export default class ZiYangDataCenter extends Vue {
  name: any = '';
  goodWhat: any = '';
  date: any = ''; // 日期
  wea: any = ''; // 天气
  tem: any = ''; // 温度
  // weaImg: any = require('@/assets/img/house/weather/yun.png'); // 温度前面的图片
  weaImg: any = ''; // 温度前面的图片

  private deptList: any = [];
  private filterForm: any = {
    deptId: '',
  };

  deptChange() {
    (this.$refs.DataBox1Ref as any).getData({ deptId: this.filterForm.deptId });
    (this.$refs.DataBox2Ref as any).getData({ topDeptId: this.filterForm.deptId });
    (this.$refs.DataBox3Ref as any).getData({ deptId: this.filterForm.deptId });
    (this.$refs.DataBox4Ref as any).getData({ topDeptId: this.filterForm.deptId });
    (this.$refs.DataBox5Ref as any).getData({ deptId: this.filterForm.deptId });
    // (this.$refs.DataBox6Ref as any).getData({ deptId: this.filterForm.deptId });
  }

  mounted() {
    const userInfo: any = JSON.parse((localStorage as any).getItem('userInfo'));
    this.filterForm.deptId = userInfo.deptId;
    this.deptChange();
    this.getWeaAndTem();
    this.getNameAndDate();
    this.getSubSpaceByAuth();
  }

  getSubSpaceByAuth() {
    // 发起接口请求，获取分页数据
    institutionServer
      .getDeptAndSubDeptList({})
      .then((res: any) => {
        this.deptList = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  getNameAndDate() {
    this.name = localStorage.getItem('name');
    const currentDate = new Date();
    const weekday = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    // this.date = currentDate.getFullYear() + '年' + (currentDate.getMonth() + 1) + '月' + currentDate.getDate() + '日' + ' ' + weekday[currentDate.getDay()];
    this.date = currentDate.getMonth() + 1 + '月' + currentDate.getDate() + '日' + ' ' + weekday[currentDate.getDay()];
    const time_range = function(beginTime: any, endTime: any) {
      const strb = beginTime.split(':');
      const stre = endTime.split(':');
      const b = new Date();
      const e = new Date();
      const n = new Date();
      b.setHours(strb[0]);
      b.setMinutes(strb[1]);
      e.setHours(stre[0]);
      e.setMinutes(stre[1]);
      if (n.getTime() - b.getTime() > 0 && n.getTime() - e.getTime() < 0) {
        console.log('true');
        return true;
      } else {
        console.log('false');
        return false;
      }
    };
    // time_range('11:32', '11:34');
    // 0:01-4:59凌晨，5-9点早上好，9.01-11.30 上午好，11.31-14:00 中午，14:01-18:30 下午，18:30-0:00 晚上
    if (time_range('0:00', '5:01')) this.goodWhat = '凌晨好';
    if (time_range('5:00', '9:01')) this.goodWhat = '早上好';
    if (time_range('9:00', '11:31')) this.goodWhat = '上午好';
    if (time_range('11:30', '14:01')) this.goodWhat = '中午好';
    if (time_range('14:00', '18:31')) this.goodWhat = '下午好';
    if (time_range('18:30', '0:01')) this.goodWhat = '晚上好';
  }

  // 天气的接口
  // 参考：http://doc.tianqiapi.com/1631612
  getWeaAndTem() {
    console.log(1);
    (this as any)
      .$axios({
        methods: 'get',
        url: 'https://tianqiapi.com/free/day',
        headers: {},
        params: {
          appid: '63848323', // 账号ID
          appsecret: '5s7y4KQg', // 账号密钥
          cityid: '101290603', // 城市编号,不要带CN, 以下参数3选1
          city: null, // 城市名称,不要带市和区
          ip: null, // IP地址
          callback: 0, // jsonp方式
        },
      })
      .then((res: any) => {
        console.log(res.data);
        this.wea = res.data.wea;
        this.tem = res.data.tem;
        switch (res.data.wea_img) {
          case 'bingbao':
            this.weaImg = require('@/assets/img/house/weather/bingbao.png');
            break;
          case 'lei':
            this.weaImg = require('@/assets/img/house/weather/lei.png');
            break;
          case 'leizhenyu':
            this.weaImg = require('@/assets/img/house/weather/leizhenyu.png');
            break;
          case 'qing':
            this.weaImg = require('@/assets/img/house/weather/qing.png');
            break;
          case 'shachen':
            this.weaImg = require('@/assets/img/house/weather/shachen.png');
            break;
          case 'wu':
            this.weaImg = require('@/assets/img/house/weather/wu.png');
            break;
          case 'xue':
            this.weaImg = require('@/assets/img/house/weather/xue.png');
            break;
          case 'yin':
            this.weaImg = require('@/assets/img/house/weather/yin.png');
            break;
          case 'yu':
            this.weaImg = require('@/assets/img/house/weather/yu.png');
            break;
          case 'yu2':
            this.weaImg = require('@/assets/img/house/weather/yu2.png');
            break;
          case 'yun':
            this.weaImg = require('@/assets/img/house/weather/yun.png');
            break;
        }
        // console.log(res.data.weaImg);
      })
      .catch((error: any) => {
        console.log(error);
      });
  }
}
